import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import Layout from "layouts/views/components/Layout";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getPreferredLocation,
  editPreferredLocationBySKU,
  deleteLocationForPrefLoc,
} from "services/data.internal.service";
import { DialogAlert } from "layouts/views/components/Alert";

import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useCustomerValue } from "providers/CustomerContext";
import EditPreferredLocationInfo from "./components/EditPreferredLocationInfo";
import { Success,Error } from "ui-components/Alert";
import { InboundLayout } from "ui-components/Layout";
function EditPreferredLocation() {
  const location = useLocation();
  const queryClient = useQueryClient();
  const { warehouseCode, zoneID, rack, mode } = location?.state ?? {};
  const [alert, setAlert] = useState(null);
  const [locId, setLocId] = useState([]);
  const [skusList, setSKUsList] = useState([]);

  const { customerCode: customerValue } = useCustomerValue();
  const customerCode = customerValue;

  const [vendorCode, setVendorCode] = useState(null);
  const [skuCode, setSKUCode] = useState(null);

  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedSKUs, setSelectedSKUs] = useState([]);
  const [routingData, setRoutingData] = useState([]);
  const [routingDirection, setRoutingDirection] = useState("no-direction");

  const { isLoading } = useQuery({
    queryKey: ["preferredLocation", [warehouseCode, zoneID, rack]],
    queryFn: () =>
      getPreferredLocation({ warehouseCode: warehouseCode, zoneID: zoneID, rack: rack }),
    refetchOnWindowFocus: false,
    enabled: warehouseCode !== undefined && zoneID !== undefined && rack !== undefined,
    onSuccess: (data) => {
      const { preferredLocationDetails, ...remainingData } = data.data.data;
      const locationItemsList = [];
      const itemLocationsList = [];

      preferredLocationDetails.forEach((detail) => {
        const { locationId, skuCode, customerCode, vendorCode, routeSequence } = detail;

        const locationIndex = locationItemsList.findIndex((data) => data.locationID === locationId);
        if (locationIndex === -1) {
          locationItemsList.push({
            locationID: locationId,
            skus: [{ skuCode, customerCode, vendorCode, routeSequence }],
          });
        } else {
          locationItemsList[locationIndex].skus.push({
            skuCode,
            customerCode,
            vendorCode,
            routeSequence,
          });
        }

        const itemIndex = itemLocationsList.findIndex(
          (data) =>
            data.skuCode === skuCode &&
            data.customerCode === customerCode &&
            data.vendorCode === vendorCode
        );
        if (itemIndex === -1) {
          itemLocationsList.push({
            skuCode,
            vendorCode,
            customerCode,
            locations: [{ locationID: locationId, routeSequence }],
          });
        } else {
          itemLocationsList[itemIndex].locations.push({ locationID: locationId, routeSequence });
        }
      });

      locationItemsList.sort((a, b) => a.locationID.localeCompare(b.locationID));
      locationItemsList.forEach((location) =>
        location.skus.sort((a, b) => a.skuCode.localeCompare(b.skuCode))
      );

      itemLocationsList.sort((a, b) => a.skuCode.localeCompare(b.skuCode));
      itemLocationsList.forEach((sku) =>
        sku.locations.sort((a, b) => a.locationID.localeCompare(b.locationID))
      );

      setLocId(locationItemsList);
      setSKUsList(itemLocationsList);
    },
    onError: (data) => {
      setAlert(<Error content={data.response.data} onChange={setAlert} />);
    },
  });

  const editPreferredLocationBySKUMutation = useMutation(editPreferredLocationBySKU, {
    onSuccess: (data) => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      queryClient.invalidateQueries(["preferredLocation"]);
      setAlert(<Success content={data.data.message} onChange={setAlert} />);
    },
    onError: (data) => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error content={data.response.data.message} onChange={setAlert} />);
    },
  });

  const deleteLocationMutation = useMutation(deleteLocationForPrefLoc, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["preferredLocation"]);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Success content={data.data.message} onChange={setAlert} />);
    },
    onError: (data) => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error content={data.response.data.message} onChange={setAlert} />);
    },
  });

  const [dialog, setDialog] = useState(null);
  const handleDel = (req) => {
    if (alert !== null) {
      setAlert(null);
    }
    if (req.locationID) {
      //call delLoc
      const { locationID, customerCode, vendorCode, skuCode } = req;
      deleteLocationMutation.mutate(
        {
          warehouseCode: warehouseCode,
          zoneID: zoneID,
          rack: rack,
          req: {
            locationIDs: locationID,
            customerCode: customerCode,
            vendorCode: vendorCode,
            skuCode: skuCode,
          },
        },
        {
          onSuccess: () => {
            setVendorCode(null);
            setSKUCode(null);
            setSelectedLocations([]);
            setSelectedSKUs([]);
            setRoutingData([]);
            setRoutingDirection("no-direction");
          },
        }
      );
    }
  };
  const handleOk = (req) => {
    handleDel(req);
    setDialog(null);
  };
  const handleClose = () => {
    setDialog(null);
  };
  const renderDialog = (req) => {
    let dialog;
    if (req.locationID) {
      if (req.locationID.length === 0) {
        setAlert(<Error content={"Invalid Location ID"} onChange={setAlert} />);
        window.scrollTo(0, 0);
        return;
      }
      const locations = req.locationID.join(", ");
      dialog = `Delete Location ${locations}`;
    }
    setDialog(
      <DialogAlert
        open={true}
        title={dialog}
        onClose={handleClose}
        onOk={() => {
          handleOk(req);
        }}
      />
    );
  };

  const editSKU = (req) => {
    const { skus, routingData } = req;
    if (skus.length === 0) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error content={"Invalid SKU"} onChange={setAlert} />);
      return;
    }

    editPreferredLocationBySKUMutation.mutate(
      {
        warehouseCode: warehouseCode,
        zoneID: zoneID,
        rack: rack,
        req: { skuList: skus, preferredLocationDetails: routingData },
      },
      {
        onSuccess: () => {
          setVendorCode(null);
          setSKUCode(null);
          setSelectedLocations([]);
          setSelectedSKUs([]);
          setRoutingData([]);
          setRoutingDirection("no-direction");
        },
      }
    );
  };

  const editStatus = editPreferredLocationBySKUMutation.status === "loading";
  return (
    <InboundLayout lg={12}>
      {alert}
      {dialog}
      {isLoading ? (
        <>
          <p>Loading...</p>
        </>
      ) : (
        <MDBox>
          <Card sx={{ height: "100%" }}>
            <MDBox p={3}>
              <EditPreferredLocationInfo
                warehouseCode={warehouseCode}
                zoneID={zoneID}
                rack={rack}
                locationsId={locId}
                skusList={skusList}
                mode={mode}
                renderDialog={renderDialog}
                editSKU={editSKU}
                customerCode={customerCode}
                vendorCode={vendorCode}
                setVendorCode={setVendorCode}
                skuCode={skuCode}
                setSKUCode={setSKUCode}
                selectedLocations={selectedLocations}
                setSelectedLocations={setSelectedLocations}
                selectedSKUs={selectedSKUs}
                setSelectedSKUs={setSelectedSKUs}
                routingData={routingData}
                setRoutingData={setRoutingData}
                routingDirection={routingDirection}
                setRoutingDirection={setRoutingDirection}
                editStatus={editStatus}
                setAlert={setAlert}
              />
            </MDBox>
          </Card>
        </MDBox>
      )}
    </InboundLayout>
  );
}

export default EditPreferredLocation